import { Action } from '@ngrx/store';
import { SelfDiagnosisModel } from './model';

export enum ActionTypes {
  FAILURE = '[SelfDiagnosis] Failure',

  GET_ALL_REQUEST = '[SelfDiagnosis] GetAll Request',
  GET_ALL_SUCCESS = '[SelfDiagnosis] GetAll Success',

  GET_BY_ID_REQUEST = '[SelfDiagnosis] GetById Request',
  GET_BY_ID_SUCCESS = '[SelfDiagnosis] GetById Success',

  UPDATE_REQUEST = '[SelfDiagnosis] Update Request',
  UPDATE_SUCCESS = '[SelfDiagnosis] Update Success',

  DELETE_REQUEST = '[SelfDiagnosis] Delete Request',
  DELETE_SUCCESS = '[SelfDiagnosis] Delete Success',

  UPLOAD_ICON_REQUEST = '[SelfDiagnosis] UploadIcon Request',
  DELETE_ICON_REQUEST = '[SelfDiagnosis] DeleteIcon Request',

  SET_SELECTED = '[SelfDiagnosis] SetSelected',
}

export class Failure implements Action {
  readonly type = ActionTypes.FAILURE;
  constructor(public error: string) {}
}

export class GetAllRequest implements Action {
  readonly type = ActionTypes.GET_ALL_REQUEST;
  constructor() {}
}

export class GetAllSuccess implements Action {
  readonly type = ActionTypes.GET_ALL_SUCCESS;
  constructor(public entities: SelfDiagnosisModel[]) {}
}

export class GetByIdRequest implements Action {
  readonly type = ActionTypes.GET_BY_ID_REQUEST;
  constructor(public id: number) {}
}

export class GetByIdSuccess implements Action {
  readonly type = ActionTypes.GET_BY_ID_SUCCESS;
  constructor(public entity: SelfDiagnosisModel) {}
}

export class UpdateRequest implements Action {
  readonly type = ActionTypes.UPDATE_REQUEST;
  constructor(public entity: SelfDiagnosisModel) {}
}

export class UpdateSuccess implements Action {
  readonly type = ActionTypes.UPDATE_SUCCESS;
  constructor(public entity: SelfDiagnosisModel) {}
}

export class DeleteRequest implements Action {
  readonly type = ActionTypes.DELETE_REQUEST;
  constructor(public id: number) {}
}

export class DeleteSuccess implements Action {
  readonly type = ActionTypes.DELETE_SUCCESS;
  constructor(public entity: SelfDiagnosisModel) {}
}

export class UploadIconRequest implements Action {
  readonly type = ActionTypes.UPLOAD_ICON_REQUEST;
  constructor(
    public entity: SelfDiagnosisModel,
    public file: File
  ) {}
}

export class DeleteIconRequest implements Action {
  readonly type = ActionTypes.DELETE_ICON_REQUEST;
  constructor(public entity: SelfDiagnosisModel) {}
}

export class SetSelected implements Action {
  readonly type = ActionTypes.SET_SELECTED;
  constructor(public entity: SelfDiagnosisModel) {}
}

export type Actions =
  | Failure
  | GetAllRequest
  | GetAllSuccess
  | GetByIdRequest
  | GetByIdSuccess
  | UpdateRequest
  | UpdateSuccess
  | DeleteRequest
  | DeleteSuccess
  | UploadIconRequest
  | DeleteIconRequest
  | SetSelected;
